/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, group: NonNullable<unknown> }} Assistant_Activity_EditedInputs */



/**
* | output |
* | --- |
* | "Edited {count} events in {group}" |
*
* @param {Assistant_Activity_EditedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_edited = /** @type {((inputs: Assistant_Activity_EditedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_EditedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Événements ${i?.count} modifiés dans ${i?.group}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Bearbeitete ${i?.count}-Ereignisse in ${i?.group}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Eventi ${i?.count} modificati in ${i?.group}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Отредактированы события ${i?.count} в ${i?.group}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se editaron los eventos ${i?.count} en ${i?.group}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已编辑 ${i?.group} 中的 ${i?.count} 事件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.group} 内の ${i?.count} イベントを編集しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.group} में ${i?.count} इवेंट संपादित किए गए`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Eventos ${i?.count} editados em ${i?.group}`)
	return /** @type {LocalizedString} */ (`Edited ${i?.count} events in ${i?.group}`)
});